'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

ErrorHandlers=function(_BaseService){_inherits(ErrorHandlers,_BaseService);
function ErrorHandlers($state,$window,Analytics){_classCallCheck(this,ErrorHandlers);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));

_this._analytics=Analytics;

_this.onSessionExpired=function(){





const authConfigName=_.get(_this.currentUser,'authConfigName');

if(authConfigName){
$window.location=`/saml2/${authConfigName}/login`;
}else{
$state.go('fdc.features.login',{sessionHasExpired:!0,return_to:encodeURIComponent($window.location.href)});
}
};

_this._handlers={
AppReloadRequiredError:function(){
$window.location.reload(!0);
},
SessionExpiredError:function(){
_this.onSessionExpired();
},
AccessDeniedError:function(){
$window.alert('Access denied, please contact your administrator.');
$window.location.reload(!1);
}};return _this;

}ErrorHandlers.prototype.

handlerFor=function handlerFor(error){
let constructorName=_.get(error,'constructor.name');

let handler;
if(_.exists(constructorName)){
handler=this._handlers[constructorName];
}

if(_.exists(handler)){
this._analytics.trackEvent('error','handled',constructorName);
}else{
let errorLabel=`${error.stack||error.description||error.message||error}`.replace(/[\r\n\t]+/g,' | ');
this._analytics.trackEvent('error','unhandled',errorLabel);
}

return handler;
};_createClass(ErrorHandlers,[{key:'currentUser',get:function()

{
return _.result(this,'getCurrentUser');
}}]);return ErrorHandlers}(BaseService);


module.exports=ErrorHandlers;
//# sourceMappingURL=errorHandlers.js.map
